/**
 * Zugriff auf das Backend.
 *
 * Die API liegt hinter demselben Ursprung wie die Seite — Firebase Hosting
 * leitet `/api/**` an den Cloud-Run-Dienst weiter. Deshalb keine absoluten
 * Adressen und kein CORS.
 *
 * Das Firebase-ID-Token hängt an jeder Anfrage. Die Quelle wird von
 * `AuthAnbieter` gesetzt, damit dieses Modul nichts von Firebase wissen muss.
 */

type TokenQuelle = () => Promise<string | null>

let tokenQuelle: TokenQuelle | null = null

export function setzeTokenQuelle(quelle: TokenQuelle | null): void {
  tokenQuelle = quelle
}

export class ApiFehler extends Error {
  readonly status: number
  readonly kennung: string

  constructor(status: number, kennung: string, meldung: string) {
    super(meldung)
    this.name = 'ApiFehler'
    this.status = status
    this.kennung = kennung
  }
}

export interface Gesundheit {
  dienst: string
  umgebung: string
  zeit: string
  status: 'ok' | 'unvollstaendig' | 'fehler'
  datenbank: {
    verbunden: boolean
    benutzer?: string
    name?: string
    version?: string | null
    grund?: string
  }
}

export async function hole<T>(pfad: string, init?: RequestInit): Promise<T> {
  const token = tokenQuelle ? await tokenQuelle() : null

  const antwort = await fetch(pfad, {
    ...init,
    headers: {
      Accept: 'application/json',
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init?.headers,
    },
  })

  const text = await antwort.text()
  const körper: unknown = text ? JSON.parse(text) : null

  if (!antwort.ok) {
    const k = körper as { fehler?: string; meldung?: string } | null
    throw new ApiFehler(
      antwort.status,
      k?.fehler ?? 'unbekannt',
      k?.meldung ?? `Anfrage fehlgeschlagen (${antwort.status})`,
    )
  }

  return körper as T
}

export const gesundheit = (): Promise<Gesundheit> =>
  hole<Gesundheit>('/api/gesundheit')
